const Api = {
    // BASE_URL: "http://localhost:8080/api",
    // BASE_URL: "http://apis.kunneh.com/api",
    
    // BASE_URL: "http://138.197.111.178:8080/api",
    BASE_URL: "https://apis.kunneh.com/api",
  };
  
  export default Api;
  